import { Button, Grid2 as Grid, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import useScreenSize from '../../../../hooks/useScreenSize';

type CampaignCountProps = {
    active: number,
    total: number,
    size?: number
}

const CampaignCountWidget = ({ active, total, size = 4 }: CampaignCountProps) => {
    const screenSize = useScreenSize();

    return (
        <Grid size={screenSize.width < 1200 ? 12 : size}>
            <Paper elevation={5} sx={{ 
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 230,
                gap: 2
            }}>
                <Typography variant="h6">Campaign Count</Typography>
                <Grid container>
                    <Grid size={6}>
                        <Typography>Active</Typography>
                        <Typography variant="h4">{active}</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography>Total</Typography>
                        <Typography variant="h4">{total}</Typography>
                    </Grid>
                </Grid>
                <Link to="/campaigns">
                    <Button variant="contained">Manage Campaigns</Button>
                </Link>
            </Paper>
        </Grid>
    )
}

export default CampaignCountWidget;
